module.exports = __webpack_public_path__ + "img/20190116.425f2b0c.png";